/**
 * WP-010 supply snapshot APIs — reports + projection simulate (ISSUE-221, ISSUE-222).
 * Backend: GET /reports/{kind}, POST /projection/simulate (see REPORT_SNAPSHOT_API_CONTRACT.md).
 */

import { apiClient } from '../apiClient';
import type {
  ProjectionSimulateRequest,
  ProjectionSimulateResponse,
  ReportSnapshotEnvelope,
  ReportSnapshotKind,
} from '../../types/clientSnapshotReports';

export async function getReportSnapshot(
  kind: ReportSnapshotKind,
  companyId: string
): Promise<ReportSnapshotEnvelope> {
  const { data } = await apiClient.get<ReportSnapshotEnvelope>(`/reports/${kind}`, {
    params: { company_id: companyId },
  });
  return data;
}

export async function postProjectionSimulate(
  body: ProjectionSimulateRequest
): Promise<ProjectionSimulateResponse> {
  const { data } = await apiClient.post<ProjectionSimulateResponse>('/projection/simulate', body);
  return data;
}
